import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestEmployeeResponse } from "@/types";

type UpdateEmploeeRequestFormData = {
  id: string;
  data: FormData;
};

async function updateEmployee(
  employeeData: UpdateEmploeeRequestFormData
): Promise<RequestEmployeeResponse> {
  const { id, ...updateData } = employeeData;

  const response = await httpRequest.post<RequestEmployeeResponse>(
    `/employees/${id}`,
    updateData.data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useUpdateEmployeeMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateEmployee,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["employees"] });
    },
  });
}
